<form #form [formGroup]="formGroup" (submit)="onFormSubmit($event)">
  <ng-content></ng-content>
</form>
